import gsap, { Power2 } from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { Maths } from '../_app/cuchillo/utils/Maths';

class ScrollItem__ProjectCard extends VScroll_Item {
  text;
  img;
  d;

  target = { x: 0, y: 0 };
  itemSize = { x: 0, y: 0 };
  ease = 0.12;

  static mouse = { x: 0, y: 0 };
  static _mouseInit = false;

  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.text = GetBy.class('__text', __link)[0];

    this.img = GetBy.selector('video', __link)[0]
    if (!this.img) this.img = GetBy.selector('img', __link)[0];
    gsap.set(this.img, { y: '-101%' });

    this.a = GetBy.selector('a', __link)[0];
    this.a.style.pointerEvents = 'none';

    this.d = parseInt(this.item.dataset.delay) * 0.1;

    if (!ScrollItem__ProjectCard._mouseInit) {
      window.addEventListener('mousemove', (e) => {
        ScrollItem__ProjectCard.mouse.x = e.clientX;
        ScrollItem__ProjectCard.mouse.y = e.clientY;
      }, { passive: true });
      ScrollItem__ProjectCard._mouseInit = true;
    }

    this.onShow = () => {
      gsap.ticker.add(this._loop);
      gsap.to(this.img, {
        y: 0,
        ease: Power2.easeOut,
        duration: 1,
        delay: this.d,
        onComplete: () => {
          this.a.style.pointerEvents = 'initial';
        }
      });
    };

    this.onHide = () => {
      gsap.ticker.remove(this._loop);
    };
  }

  _loop = () => {
    this.target.x = Maths.lerp(this.target.x, ScrollItem__ProjectCard.mouse.x + 10 - this.itemSize.x, this.ease);
    this.target.y = Maths.lerp(this.target.y, ScrollItem__ProjectCard.mouse.y + 10 - this.itemSize.y - Scroll.y, this.ease);
    const offsetX = this.target.x;
    const offsetY = this.target.y;

    gsap.set(this.text, {
      left: offsetX,
      top: offsetY
    });
  };

  resize() {
    super.resize();

    const rect1 = this.item.getBoundingClientRect();
    this.itemSize.x = rect1.left;
    this.itemSize.y = rect1.top;
  }

  //=============================
  // DISPOSE GLOBAL
  //=============================
  dispose() {
    super.dispose();

    if (ScrollItem__ProjectCard._mouseInit) {
      // elimina listeners globals i ticker
      window.removeEventListener('mousemove', ScrollItem__ProjectCard._onMouseMove);
      ScrollItem__ProjectCard._mouseInit = false;
    }
  }
}

Scroll._registerClass('project-card', ScrollItem__ProjectCard);
